import styled from "styled-components";
import {Text1, Title2} from "../../../styles/components";
import {Title1} from "../../../styles/business-components";
import Image from '../../../assets/images/business/b_about_img3.png'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;
  margin-bottom: 10vh;
  padding: 20px;
  color: ${({theme}) => theme.colors.black};

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    padding: 5vh 15%;
  }
`

export const Title = styled(Title2)`
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
  text-transform: uppercase;
  color: ${({theme}) => theme.colors.title};
  text-align: center;

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 40px;
  }
`

export const SubText = styled(Text1)`
  display: block;
  color: ${({theme}) => theme.colors.text};
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 24px;
    font-weight: 400;
    line-height: 60px;
    text-align: center;
    margin-bottom: 100px;
  }
`

export const SupportText = styled(SubText)`
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  margin-bottom: 2rem;

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 24px;
    font-weight: 400;
    line-height: 60px;
    text-align: center;
    margin-bottom: 100px;
  }
`

export const SupportTitle = styled(Title1)`
  font-size: 18px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  margin-bottom: 20px;

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 28px;
    line-height: 50px;
    font-weight: 600;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 32px;
    line-height: 60px;
    margin-bottom: 50px;
  }
`

export const SupportBlock = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;

  @media only screen and (${({theme}) => theme.media.large}) {
    margin-top: 100px;
    padding: 0 50px;
    gap: 80px;
  }
`

export const ImageBlock = styled.div`
  background: url(${Image}) center no-repeat ${({theme}) => theme.business.colors.aboutImageBackground};
  background-size: contain;
  width: 120px;
  height: 120px;
  border-radius: 250px 250px 2px 250px;
  flex-basis: 30%;

  @media only screen and (${({theme}) => theme.media.large}) {
    width: 500px;
    height: 500px;
    border-radius: 250px 250px 250px 2px;
  }
`